// extracted by mini-css-extract-plugin
export var smallSpinner = "_x4-0";